/*
 * Twitter Bootstrap 4 plugin for AngularJS.
 * Copyright (c) 2016-2021 Rodziu <mateusz.rohde@gmail.com>
 * License: MIT
 */
import { angularBS } from './lib/angularBS.module';
export * from './lib/carousel/carousel.provider';
export * from './lib/helpers/angularBS.service';
export * from './lib/modal/modal.provider';
export { BSModalController } from './lib/modal/bs-modal.directive';
export * from './lib/popover/popover.provider';
export * from './lib/toasts/toasts.provider';
export * from './lib/tooltip/tooltip.provider';
export default angularBS;
